module.exports = __webpack_public_path__ + "wxres/vue/img/padcontrol_home_preview2.b206d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padcontrol_home_preview2.png
// module id = b/Ax
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82